import React, {useState} from "react"
import {ClientKey} from "../../../config/app-config"
import {themeByClientKey} from "../../../theme/theme"

type Props = {
  clientKey: ClientKey
  onSubmit: (email: string) => void
  loginPageTitle: {
    title: string
  }
}
export const ForgetPasswordForm: React.FC<Props> = ({
  clientKey,
  onSubmit,
  loginPageTitle,
}) => {

  const [email, setEmail] = useState<string>("")
  const { buttonClass: buttonClassName, systemSubtitle, titleClassName } = themeByClientKey(clientKey)

  function handleKeyPress(event: any) {
    if (event.key === "Enter") {
      onSubmit(email)
    }
  }

  return <>
    <div className="form-layout">
      <div className="form">
        <div className="detail">
          <p className={ titleClassName } style={{textAlign: "center"}}>{ loginPageTitle.title }</p>
          <p className="header" style={{textAlign: "center"}}>{ systemSubtitle }</p>
        </div>
        <div style={{fontWeight: 500, fontSize: "18px"}} className="mb-3">
          <label htmlFor="txtUsername">Email
            <input
              type="email"
              className="input"
              value={email}
              onChange={(evt) => setEmail(evt.target.value)}
              id="txtEmail"
              placeholder="youremail@yourorg.com"
              onKeyPress={handleKeyPress}
            />
          </label>

        </div>

        <div className="mb-5">
          <button type="button" onClick={() => onSubmit(email)} className={ buttonClassName }>Reset Password</button>
          <br/>
        </div>
        <br/>
      </div>
    </div>
  </>
}